import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { MatDatepickerModule } from '@angular/material/datepicker'
import { MatNativeDateModule } from '@angular/material/core'
import { MatProgressSpinner } from '@angular/material/progress-spinner'

import { MonitoringService } from '../../../core/services/monitoring/monitoring.service'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { FaseFarolVm, LinhaMonitoramentoVm } from '../../../core/models/monitoring-os.model'

// Confirmar uma fase adiantada grava também as etapas do meio (mesma data/hora,
// com uma observação de origem) — por isso o modal só recarrega a linha ao fechar,
// nunca tenta reconstruir localmente quais fases ficaram confirmadas.
@Component({
  selector: 'modal-confirmar-fase',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatProgressSpinner,
  ],
  templateUrl: './modal-confirmar-fase.component.html',
  styleUrl: './modal-confirmar-fase.component.scss',
})
export class ModalConfirmarFaseComponent implements OnInit {
  @Output() response = new EventEmitter<boolean>()

  constructor(
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: { item: LinhaMonitoramentoVm; fase: FaseFarolVm },
    private dialogRef: MatDialogRef<ModalConfirmarFaseComponent>,
    private monitoringService: MonitoringService,
    private snackbar: SnackbarCustomService,
  ) {}

  form!: FormGroup
  saving = false
  changed = false

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      dataOcorrido: [null],
      horaOcorrido: [''],
      observacao: [''],
    })
  }

  confirmar(): void {
    this.saving = true
    const v = this.form.value
    const body: { dataOcorrido?: string; horaOcorrido?: string; observacao?: string } = {}
    if (v.dataOcorrido) body.dataOcorrido = this.formatDate(v.dataOcorrido)
    if (v.horaOcorrido) body.horaOcorrido = v.horaOcorrido
    if (v.observacao) body.observacao = v.observacao

    this.monitoringService.confirmarFase(this.data.item.codigoOs, this.data.fase.numero, body).subscribe({
      next: (res: any) => {
        this.saving = false
        this.changed = true
        this.snackbar.success(res.message ?? 'Fase confirmada com sucesso.')
        this.close()
      },
      error: (err: any) => {
        this.saving = false
        this.snackbar.errorRequest(err)
      },
    })
  }

  private formatDate(date: Date): string {
    const day = date.getDate().toString().padStart(2, '0')
    const month = (date.getMonth() + 1).toString().padStart(2, '0')
    return `${day}/${month}/${date.getFullYear()}`
  }

  close(): void {
    this.response.emit(this.changed)
    this.dialogRef.close()
  }
}
